import { render, staticRenderFns } from "./PrivateMessage.vue?vue&type=template&id=c78dff2c&scoped=true"
import script from "./PrivateMessage.vue?vue&type=script&lang=js"
export * from "./PrivateMessage.vue?vue&type=script&lang=js"
import style0 from "./PrivateMessage.vue?vue&type=style&index=0&id=c78dff2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78dff2c",
  null
  
)

export default component.exports